import type { FillLayerSpecification, VectorSourceSpecification } from 'mapbox-gl';

export const AT_BEZIRK_SOURCE_ID = 'bezirk';
export const AT_BEZIRK_LAYER_NAME = 'bezirk';

export const AT_BEZIRK_LAYER_CONFIG: FillLayerSpecification = {
  id: AT_BEZIRK_LAYER_NAME,
  type: 'fill',
  source: AT_BEZIRK_SOURCE_ID,
  'source-layer': 'municipalities',
  paint: {
    'fill-outline-color': 'rgba(0,0,0,0.3)',
    'fill-color': 'rgba(0,0,0,0.1)',
  },
};

export const AT_BEZIRK_SOURCE: VectorSourceSpecification = {
  type: 'vector',
  url: 'mapbox://sseemann.at-municipalities-dev',
};

export interface AT_BEZIRK_SOURCE_FEATURE_PROPERTIES {
  color: string;
  displayName: string;
  key: string;
}
